<script>
import displaySettings from "@/mixin/displaySettings";
import { SmartLink } from '@/shared/ui/link';
import { BlueButton } from '@/shared/ui/form';

export default {
  name: "QuotationSuccessDialog",
  components: { SmartLink, BlueButton },
  props: ['dialogVisible', 'quotation', 'quotationData', 'draftStatus'],
  mixins: [displaySettings],
  computed: {
    isDraft() {
      return this.draftStatus ?? false;
    }
  },
  methods: {
    reloadPage() {
      this.$emit('update:dialogVisible', false);
      //location.reload(false)
      this.$router.push({name: 'quotations'})
    },
    closeModal() {
      this.$emit('update:dialogVisible', false);
    },
  },
}
</script>

<template>
  <div class="quotation-success">
    <el-dialog
      :width="isMobile ? '94%' : '80%'"
      :visible.sync="dialogVisible"
      center
      top="30vh"
      :before-close="closeModal"
      custom-class="py-4"
    >
      <div slot="title">
        <div v-if="isDraft && quotation" class="title mb-2">Чернетку {{ quotation.name }} сформовано успішно</div>
        <div v-else-if="quotation" class="title mb-2">Запит на прорахунок {{ quotation.name }} успішно відправлено</div>
      </div>
      <div class="description">
        Після переоформлення договір надійде на пошту, а також його можна завантажити в “історії замовлень”
      </div>
      <div slot="footer">
        <el-row>
          <el-col>
            <el-button type="primary self-blue" class="w-100" @click="reloadPage">до Центру котирування</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss">
@import "./styles/quotation-modal.scss";
</style>
